import apiClient from "./apiClient";
import { OutboxDashboardResponse } from "../types/outbox.types";

/**
 * Fetch Outbox Dashboard data
 */
export const getOutboxDashboard = async (): Promise<OutboxDashboardResponse> => {
  const { data } = await apiClient.get<OutboxDashboardResponse>("/admin/outbox/dashboard");
  return data;
};

/**
 * Replay a failed outbox event
 */
export const replayOutboxEvent = async (eventId: string): Promise<void> => {
  await apiClient.post(`/admin/outbox/${eventId}/replay`);
};
